import React, { useState } from "react";
// @material-ui/core components
import {
  Dialog,
  makeStyles,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  IconButton,
} from "@material-ui/core";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import axios from "axios";
import {
  baseUrl,
  GetAllLedgersAPI,
  GetAllPaymentsAPI,
} from "../../config/api";
import DateUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ClearIcon } from "@mui/x-date-pickers";
import { ledgerTemplate } from "../../assets/html/ledgerTemplate.js";
import { useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { paymentLedger } from "../../assets/html/paymentLedger.js";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const styles = {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};
const useStyles = makeStyles(styles);

export default function Ledger(props) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  let types = [
    {
      label: "Challan",
      value: "Challan",
    },
    {
      label: "Bill",
      value: "Bill",
    }
  ];

  const {
    openLedgerSelectionDialog,
    setOpenLedgerSelectionDialog,
    setOpenLedgerDialog,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    ledgerType,
    setLedgerType,
    item,
    pay,
  } = props;

  const [openingBalance, setOpeningBalance] = useState();
  const [pdfBlob, setPdfBlob] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSharing, setIsSharing] = useState(false);

  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);

  const [selectedDate, setSelectedDate] = useState([null, null]);

  const handleDateChange = (dateRange) => {
    setSelectedDate(dateRange);
  };

  // Separate function to generate PDF blob
  async function generatePdfBlob(ledgerData, backBalance, ongoingBalance, tempBalance) {
    try {
      let htmlData;

      if (pay) {
        console.log("the payger")
        htmlData = {
          ledgers: ledgerData,
          ledgerType: "payment",
          startDate,
          endDate,
          clientName: item.bankName,
          clientAddress: item.address || "",
          pay: true,
          closingBalance: tempBalance,
        };
      } else {
        console.log("the ledger")
        htmlData = {
          ledgers: ledgerData,
          ledgerType: ledgerData[0]?.transactionType || "",
          startDate,
          endDate,
          clientName: item.name,
          clientAddress: item.address || "",
          closingBalance: tempBalance,
          openingBalance: backBalance,
        };
      }

      // Use standard A4 size
      const options = {
        orientation: "p",
        unit: "pt",
        format: "a4",  // Standard A4: 595pt × 842pt
        putOnlyUsedFonts: true,
      };

      console.log("the htmlData", htmlData, "temptime")

      // Generate the PDF blob directly from the template function
      const pdfBlob = pay ? paymentLedger(htmlData) : ledgerTemplate(htmlData);
      return pdfBlob;
    } catch (error) {
      //console.error("PDF generation error:", error);
      throw error;
    }
  }

  async function sendWhatsAppMessage(generatedPdfBlob, startDate, endDate, item, backBalance, ongoingBalance) {
    console.log("Sending WhatsApp message with PDF blob:", generatedPdfBlob, startDate, endDate, item, backBalance, ongoingBalance);
    // return false
    try {
      const formData = new FormData();
      formData.append('file', pdfBlob, 'ledger.pdf');
      formData.append('phone', item.whatsappNumber || item.mobile);
      formData.append('template', 'send_ledgers');
      formData.append('clientName', item.name || item.bankName); // {{1}}
      formData.append('startDate', moment(startDate).format('DD/MM/YYYY')); // {{2}}
      formData.append('endDate', moment(endDate).format('DD/MM/YYYY'));     // {{3}}
      formData.append('openingBalance', openingBalance);                    // {{4}}
      // formData.append('closingBalance', closingBalance);                    // {{5}}
      // Optionally, add entityName if needed for sender selection

      const response = await axios.post(`${baseUrl}/send-whatsapp/ledgers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.data.success) {
        toast.success("Ledger sent successfully on WhatsApp!");
        return true;
      } else {
        throw new Error(response.data.message || "Failed to send WhatsApp message");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Failed to send ledger on WhatsApp");
      return false;
    }
  }

  // Main function to fetch ledger data
  async function fetchLedgerData() {
    try {

      if (pay) {
        let bankName = item.bankName;
        let query = `&bankName=${bankName}`;

        let res = await axios.get(GetAllPaymentsAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const filteredRecords = res.data.payments.filter((record) =>
          moment(record.date).isBetween(startDate, endDate, null, "[]")
        );

        return {
          ledgerData: filteredRecords,
          backBalance: 0,
          ongoingBalance: 0,
          tempBalance: 0
        };

      } else {
        // Get ledger data for non-payment types
        let query;

        if (ledgerType === "Challan") {
          query = `&accountId=${item._id}&transactionType=challan&transactionType=credit&transactionType=debit`;
        } else if (ledgerType === "Bill") {
          query = `&accountId=${item._id}&transactionType=bill&transactionType=credit&transactionType=debit`;
        }

        let res = await axios.get(GetAllLedgersAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        console.log('all challan records', res.data.ledgers);

        // Calculate opening balance from records strictly before the selected start date (date-only comparison)
        const filteredRecords = res.data.ledgers.filter((record) => {
          return moment(record.date)
            .startOf('day')
            .isBefore(moment(startDate).startOf('day'));
        });

        console.log('all records before start date', filteredRecords);

        console.log('selected company', item)

        let currentOpeningChallanBalance = item.openingChallanBalance || 0;
        let currentOpeningBillBalance = item.openingBillBalance || 0;

        console.log('all opening balances', currentOpeningChallanBalance, currentOpeningBillBalance);

        let backBalance = filteredRecords.reduce((sum, record) => {
          if (record.type === "credit" && record.activityType === "sale" && record.transactionType === "challan") {
            return sum - Number(record.amount);
          } else if (record.type === "credit" && record.activityType === "purchase" && record.transactionType === "challan") {
            return sum + Number(record.amount);
          } else if (record.type === "debit" && record.activityType === "sale" && record.transactionType === "challan") {
            return sum + Number(record.amount);
          } else if (record.type === "debit" && record.activityType === "purchase" && record.transactionType === "challan") {
            return sum - Number(record.amount);
          } else if (record.type === "credit" && record.activityType === "sale" && record.transactionType === "bill") {
            return sum - Number(record.amount);
          } else if (record.type === "credit" && record.activityType === "purchase" && record.transactionType === "bill") {
            return sum + Number(record.amount);
          } else if (record.type === "debit" && record.activityType === "sale" && record.transactionType === "bill") {
            return sum + Number(record.amount);
          } else if (record.type === "debit" && record.activityType === "purchase" && record.transactionType === "bill") {
            return sum - Number(record.amount);
          }
          return sum;
        }, 0);

        console.log('all back balances', backBalance);

        if (ledgerType === "Challan") {
          backBalance = backBalance + currentOpeningChallanBalance;
        } else if (ledgerType === "Bill") {
          backBalance = backBalance + currentOpeningBillBalance;
        }

        console.log('all back balances after opening balances', backBalance);

        // Get records within date range
        // const filteredRecords2 = res.data.ledgers.filter((record) =>
        //   moment(record.date).startOf('day').isBetween(
        //     moment(startDate).startOf('day'),
        //     moment(endDate).startOf('day'),
        //     null,
        //     "[]"
        //   )
        // );


        const filteredRecords2 = res.data.ledgers.filter((record) => {
          // console.log('allRecords55', moment(record.date), moment(startDate).startOf('day'), moment(endDate).endOf('day'));
          return moment(record.date).isBetween(
            moment(startDate).startOf('day'),
            moment(endDate).endOf('day'),
            null,
            '[]'
          )
        });

        console.log('all records within date range', filteredRecords2);

        const ongoingBalance = filteredRecords2.reduce((sum, record) => {
          if (record.type == "credit" && record.activityType == "sale" && record.transactionType == "challan") {
            return sum - Number(record.amount);
          } else if (record.type == "credit" && record.activityType == "purchase" && record.transactionType == "challan") {
            return sum + Number(record.amount);
          } else if (record.type == "debit" && record.activityType == "sale" && record.transactionType == "challan") {
            return sum + Number(record.amount);
          } else if (record.type == "debit" && record.activityType == "purchase" && record.transactionType == "challan") {
            return sum - Number(record.amount);
          } else if (record.type == "credit" && record.activityType == "sale" && record.transactionType == "bill") {
            return sum - Number(record.amount);
          } else if (record.type == "credit" && record.activityType == "purchase" && record.transactionType == "bill") {
            return sum + Number(record.amount);
          } else if (record.type == "debit" && record.activityType == "sale" && record.transactionType == "bill") {
            return sum + Number(record.amount);
          } else if (record.type == "debit" && record.activityType == "purchase" && record.transactionType == "bill") {
            return sum - Number(record.amount);
          }
          return sum;
        }, 0);

        console.log('all ongoing balances', ongoingBalance);

        let fd = _.sortBy(filteredRecords2, (obj) => obj.date);
        let tempBalance = Number(backBalance) + Number(ongoingBalance);

        console.log('all sorted records and temp balance', fd, tempBalance);

        setOpeningBalance(tempBalance);

        return {
          ledgerData: fd,
          backBalance,
          ongoingBalance,
          tempBalance
        };
      }
    } catch (error) {
      //console.error("Error fetching ledger data:", error);
      throw error;
    }
  }

  // Handle generate ledger (view only)
  async function handleGenerateLedger() {
    if (!startDate || !endDate || startDate >= endDate) {
      alert("Please provide valid start and end dates.");
      return;
    }

    setIsGenerating(true);
    try {
      const { ledgerData, backBalance, ongoingBalance, tempBalance } = await fetchLedgerData();
      console.log('ledgerData', backBalance, ongoingBalance, tempBalance);

      // Remove the check for ledgerData length
      // Always generate the PDF if backBalance is available
      console.log("pdfstart")
      const generatedPdfBlob = await generatePdfBlob(ledgerData, backBalance, ongoingBalance, tempBalance);
      console.log("generatedPdfBlob", generatedPdfBlob)
      setPdfBlob(generatedPdfBlob);
      console.log("pdfend")
      // Only open the PDF in a new tab here, NOT in WhatsApp share logic
      window.open(URL.createObjectURL(generatedPdfBlob));
      setIsGenerating(false);
    } catch (error) {
      //console.error("Error generating ledger:", error);
      toast.error("Failed to generate ledger");
    } finally {
      setIsGenerating(false);
    }
  }

  // Handle share via WhatsApp
  async function handleWhatsAppShare() {
    if (!startDate || !endDate || startDate >= endDate) {
      alert("Please provide valid start and end dates.");
      return;
    }

    if (!item.whatsappNumber && !item.mobile) {
      toast.error("No WhatsApp number found for this Account");
      return;
    }

    setIsSharing(true);
    try {
      console.log("fetching data ledger")
      const { ledgerData, backBalance, ongoingBalance, tempBalance } = await fetchLedgerData();
      console.log("got ledger data")

      if (!ledgerData || ledgerData.length < 1) {
        toast.error("No records found to generate the ledger");
        return;
      }
      // if (item?.whatsappNumber) {
      //   toast.error("No number found to send whatsapp message.");
      //   return;
      // }
      console.log("generate pdf>>>>>>>")

      const generatedPdfBlob = await generatePdfBlob(ledgerData, backBalance, ongoingBalance, tempBalance);
      console.log("got generated pdf>>>>>>>")
      setPdfBlob(generatedPdfBlob);

      console.log("start share")
      // DO NOT open the PDF in a new tab here. Only share via API.
      // No window.open or similar logic should be here.

      console.log("Sharing ledger on WhatsApp...");

      const formData = new FormData();
      formData.append('file', generatedPdfBlob, 'ledger.pdf');
      formData.append('phone', item.whatsappNumber || item.mobile);
      formData.append('template', 'send_ledgers');
      formData.append('clientName', item.name || item.bankName); // {{1}}
      formData.append('startDate', moment(startDate).format('DD/MM/YYYY')); // {{2}}
      formData.append('endDate', moment(endDate).format('DD/MM/YYYY'));     // {{3}}
      formData.append('openingBalance', backBalance);                    // {{4}}
      formData.append('closingBalance', ongoingBalance);                    // {{5}}
      // Optionally, add entityName if needed for sender selection

      const response = await axios.post(`${baseUrl}/send-whatsapp/ledgers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log(response.data, "<<<<<<<<<aagya")

      if (response.data.success) {
        toast.success("Ledger sent successfully on WhatsApp!");
        return true;
      } else {
        throw new Error(response.data.message || "Failed to send WhatsApp message");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Failed to share ledger on WhatsApp");
    } finally {
      setIsSharing(false);
    }
  }

  return (
    <Dialog
      onClose={() => setOpenLedgerSelectionDialog(false)}
      aria-labelledby="simple-dialog-title"
      open={openLedgerSelectionDialog}
      fullScreen={fullScreen}
    >
      <GridContainer style={{ margin: "0px !important" }}>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Ledger</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  {!pay && (
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ledgerType}
                        label="Type"
                        onChange={(e) => {
                          setLedgerType(e.target.value);
                        }}
                      >
                        {types.map(({ label, value }) => (
                          <MenuItem value={value} key={value}>
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </GridItem>
                <MuiPickersUtilsProvider utils={DateUtils}>
                  <GridItem
                    xs={12}
                    style={{
                      marginTop: 20,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      fullWidth
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      animateYearScrolling
                    />
                    <IconButton onClick={() => setStartDate(null)} edge="end">
                      <ClearIcon />
                    </IconButton>
                  </GridItem>
                  <GridItem
                    xs={12}
                    style={{
                      marginTop: 20,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DatePicker
                      label="End Date"
                      fullWidth
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                      animateYearScrolling
                    />
                    <IconButton onClick={() => setEndDate(null)} edge="end">
                      <ClearIcon />
                    </IconButton>
                  </GridItem>
                </MuiPickersUtilsProvider>
              </GridContainer>
            </CardBody>
            <CardFooter style={{ justifyContent: "center", gap: "1rem" }}>
              <Button
                type="button"
                color="primary"
                onClick={handleGenerateLedger}
                disabled={!startDate || !endDate || isGenerating || isSharing}
              >
                {isGenerating ? "Generating..." : "Generate Ledger"}
              </Button>

              <Button
                type="button"
                color="success"
                onClick={handleWhatsAppShare}
                disabled={!startDate || !endDate || isGenerating || isSharing}
                startIcon={<WhatsAppIcon />}
              >
                {isSharing ? "Sharing..." : "Share on WhatsApp"}
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}